import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import * as Icons from "heroicons-react";
import RTVprint from "../PrintReceipt/RTV/RTVprint";
import { useRtvQuery, useUpdateRtvMutation } from "../../../services/rtvApi";

function RtvView({ show, handleClose, grn }) {
  const componentRef = useRef();
  const grnView = useRtvQuery(grn);

  const [updateRtv] = useUpdateRtvMutation();

  //   console.log(grnView.data);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const printRecipt = async () => {
    handlePrint();
    if (!grnView?.data?.print) {
      const updatePrint = await updateRtv({
        _id: grnView?.data?._id,
        print: true,
      });
      if (updatePrint) {
        console.log("print Orignal:", updatePrint);
      }
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header className="d-flex justify-content-end" closeButton>
        <Modal.Title>Return To Vendor</Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-auto">
        <RTVprint ref={componentRef} grn={grnView?.data} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <button className="btn btn-dark float-end" onClick={printRecipt}>
          <Icons.PrinterOutline className="ms-3" size={18} /> Print{" "}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default RtvView;
